<script lang="ts">
export default {
    name: "PhotoPop",
};
</script>

<script setup lang="ts">
import { onMounted } from "vue"
import { store } from '@/store'
import AMapLoader from '@amap/amap-jsapi-loader';
import { useFormatDate } from "@/hooks/userHookDate"
import GPS from '@/utils/gps-convert'
import eventicon from '@/assets/images/eventicon.svg'
import { clickAlert } from "@/api/Local/index"
import MapInit from '@/utils/mapinit'

const props = defineProps({
    photoVisible: {
        type: Boolean,
        default: () => {
            return false;
        },
    },
    photoIndex: {
        type: Number,
        default: () => {
            return 0;
        },
    }
});

const activeIndex = ref(0);

const useDate = useFormatDate()

const popList = ref()

const emits = defineEmits(["update:photoVisible"]);

const openValue = ref(false)

const closeDialog = () => {
    if (canvasCtx.value) {
        // 清除Canvas
        canvasCtx.value.clearRect(0, 0, canvasCtx.value.canvas.width, canvasCtx.value.canvas.height);
        canvasCtx.value = null
    }
    if (mapContainer.value) {
        // mapContainer.value.destroy(); // 销毁地图实例
        mapContainer.value = null
        mapContainerRef.value = null
    }
    openValue.value = false
    emits("update:photoVisible", false);
}
const mapContainerRef = ref()
const mapContainer = ref()
const initgdMap = () => {
    MapInit.init()
        .then((T: any) => {

            // 创建地图实例
            mapContainer.value = new T.Map(mapContainerRef.value,);
            // 设置地图中心点和缩放级别
            mapContainer.value.centerAndZoom(new T.LngLat(Number(popList.value.lng), Number(popList.value.lat)), 16);
            const marker = new T.Marker(new T.LngLat(Number(popList.value.lng), Number(popList.value.lat)));
            mapContainer.value.addOverLay(marker);
        })
        .catch()
}

const canvasCtx: any = ref();

const handleChange = () => {
    if (openValue.value) {
        getCanvas()
    } else {
        // 清除Canvas
        canvasCtx.value.clearRect(0, 0, canvasCtx.value.canvas.width, canvasCtx.value.canvas.height);
    }
}

const carouselChange = (newVal: any, oldVal: any) => {
    activeIndex.value = newVal
    if (openValue.value) {
        // 清除Canvas
        canvasCtx.value.clearRect(0, 0, canvasCtx.value.canvas.width, canvasCtx.value.canvas.height);
        getCanvas()
    }
}

const getCanvas = () => {
    let canvas: any = document.getElementById('canvas')
    const rect = canvas.getBoundingClientRect()
    canvas.width = rect.width;
    canvas.height = rect.height;
    canvasCtx.value = canvas.getContext('2d');
    canvasCtx.value.strokeStyle = 'red';
    canvasCtx.value.lineWidth = 1
    let rects: any = [];
    popList.value.eventImages[activeIndex.value].box.forEach((result: any, index: any) => {
        rects.push({
            x: result.x * canvas.width, y: result.y * canvas.width, width: result.width * canvas.width, height: result.height * canvas.width, color: 'red', className: result.className
        })
    })
    rects.forEach((rect: any) => {
        canvasCtx.value.strokeRect(rect.x, rect.y, rect.width, rect.height)
        if (rect.className) {
            // 绘制文字
            canvasCtx.value.font = '20px Arial';
            canvasCtx.value.fillStyle = '#fc0605';
            canvasCtx.value.fillText(rect.className, rect.x, rect.y);
        }
    });
}

const handleDialogOpen = () => {
    activeIndex.value = props.photoIndex
    popList.value = store.informationListStore.informationStore().waringList
    console.log(popList.value)
    initgdMap()
}
const orgid = localStorage.getItem("orgid") || "";

const treatBtn = () => {
    const centre = GPS.gcj_encrypt(Number(popList.value.lat), Number(popList.value.lng))
    console.log(centre)
    clickAlert({ longitude: centre.lon, latitude: centre.lat, sn: popList.value.gatewaySn, height: "150", orgId: orgid }).then(res => {
        ElMessage.success('准备出警')
    })
}

onMounted(() => {
})
</script>

<template>
    <el-dialog class="dialogBox" @open="handleDialogOpen" destroy-on-close v-model="props.photoVisible" title="事件照片："
        @close="closeDialog">
        <div class="left-pop" v-if="popList">
            <div class="left-word">拍摄位置：</div>
            <div ref="mapContainerRef" class="mapBox"></div>
            <div class="left-word">事件类型：</div>
            <div class="left-word">{{ popList.eventType }}</div>
            <div class="left-word" style="margin-top:1.5rem;">发生时间：</div>
            <div class="left-word">{{ popList.eventTime }}</div>
            <div class="Treatbtn" @click="treatBtn">出警</div>
        </div>
        <span v-if="popList">
            <div style="display: flex;justify-content: space-between;align-items: center;">
                <p style="color: #fff;">
                    <span style="display: inline-block;">事件类型：{{ popList.eventType }}</span>
                    <span style="display: inline-block;margin-left: 100px;">预警编号：{{ popList.warningId }}</span>
                </p>
                <el-form-item label="叠加识别框" label-position="left">
                    <el-switch inline-prompt active-text="开" inactive-text="关" v-model="openValue"
                        @change="handleChange" />
                </el-form-item>
            </div>
            <div style="position: relative;" class="picBox">
                <canvas id="canvas" class="imgCanvas"></canvas>
                <div class="carouselBox" v-if="popList.eventImages.length">
                    <el-carousel style="width: 100%;height: 100%;" :autoplay="false" :initial-index="photoIndex"
                        @change="carouselChange" trigger="click">
                        <el-carousel-item style="width: 100%;height: 100%;"
                            v-for="(item, index) in popList.eventImages.slice(0, 8)" :key="index">
                            <img style="width:100%;" v-if="popList.eventImages && popList.eventImages.length"
                                :src="item.image" alt="">
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </div>
        </span>
    </el-dialog>
</template>

<style lang="scss">
.dialogBox {
    width: 45.6vw;
    height: 60.3vh;
    background: url("@/assets/images/pop-pic.png") no-repeat center;
    background-size: 100% 100%;
    padding: .625rem 1rem;
    margin-left: 35.5vw;

    .el-dialog__title {
        color: #fff;
        font-family: AlibabaPuHuiTi;
    }

    .left-pop {
        width: 15vw;
        height: 40vh;
        border-radius: 5px;
        background: url("@/assets/icons/small-pop.png") no-repeat center;
        background-size: cover;
        position: absolute;
        top: 0;
        left: -17vw;
        padding: 1rem;
        color: #fff;

        .left-word {
            font-family: AlibabaPuHuiTi;
            margin-bottom: 0.625rem;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            /* 控制显示的行数 */
        }

        .left-word {
            display: -moz-box;
            -moz-line-clamp: 2;
            -moz-box-orient: vertical;
        }

        .mapBox {
            width: 13.3vw;
            height: 19vh;
            margin-bottom: 0.625rem;
            position: relative;
        }

        .Treatbtn {
            width: 3.9vw;
            height: 2vh;
            border-radius: 3px;
            background: linear-gradient(270deg, rgba(253, 202, 0, 0.8) 0%, rgba(248, 128, 0, 0.6) 100%);
            box-sizing: border-box;
            // border: 0.5px solid;
            border-image: linear-gradient(270deg, #FFFFFF 0%, #FAA700 97%) 0.5;
            text-align: center;
            line-height: 2vh;
            font-size: .75rem;
            font-family: AlibabaPuHuiTi;
            color: #fff;
            cursor: pointer;
        }
    }

    .el-form-item {
        margin-bottom: 0;

        .el-form-item__label {
            color: #fff;
            font-family: AlibabaPuHuiTi;
        }

        .el-switch {
            .el-switch__label {
                color: #E8EBEF;
            }

            .el-switch__core {
                background: linear-gradient(115deg, rgba(73, 73, 73, 0.83) 0%, #DCDCDC 100%);
                border: none;
            }
        }

        .el-switch.is-checked {
            .el-switch__core {
                background: linear-gradient(115deg, rgba(64, 255, 249, 0.83) 0%, #408CFF 100%);
                border: none;
            }
        }
    }

    .picBox {
        .imgCanvas {
            width: 43.6vw;
            height: 100%;
            position: absolute;
            z-index: 1;
            pointer-events: none;
        }

        .carouselBox {
            position: relative;
            width: 43.6vw;
            height: 100%;
            .el-carousel__container{
                height: 480px;
            }
        }
    }
}
</style>